import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { authApi } from '../api/auth.js';
import { useSession } from '../store/session.js';
import { toast } from '../store/toast.js';

/** 退出登录（Layout 与移动端「更多」面板共用）：尽力撤销服务端 refresh token，本地必清。 */
export function useLogout(): () => void {
  const refreshToken = useSession((state) => state.refreshToken);
  const clear = useSession((state) => state.clear);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return () => {
    if (refreshToken) {
      // 尽力撤销服务端 refresh token；失败也只是留下一条无效记录，不阻塞本地登出
      void authApi.logout(refreshToken).catch(() => undefined);
    }
    clear();
    queryClient.clear();
    toast.info('已退出登录', '本地会话已清空');
    navigate('/login', { replace: true });
  };
}
